import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Landscape patterns plays an important role in ecological processes
              and the structure of a landscape, shape and configuration are
              responsible for its functional aspects such as bio-geo chemical
              cycling and hydrologic regimes (Chen et al. 2014; Ramachandra et
              al. 2016). The landscape transition can be natural or
              anthropogenic. The several studies across the globe have proved
              the anthropogenic activities are altering the global climate (Peng
              et al. 2011; Newbold et al. 2015; Grizzetti et al. 2017; Szymura
              et al. 2018). The abrupt environmental changes at local, regional
              and global scales are threatening the survival of humans and other
              biota. Land use land cover (LULC) are the important parameters of
              landscape which reflects its change characteristics (Ganasri et
              al. 2010). LC refers to the observed physical cover on the earth's
              surface whereas LU expresses arrangements, activities and inputs
              people undertake in a certain LC. LULC change is governed by the
              crucial drivers such as population, urban expansion, agricultural
              production and land management policies, which alters a landscape
              into heterogeneous mosaic of patches (Ramachandra et al. 2012).
              LULC alterations will affect the range of functionalities of
              landscape such as nutrient cycling, bio-geochemical cycle,
              hydrologic cycling, carbon sequestration potential, water
              retention capability, etc. (Ramachandra et al. 2018; Ramachandra
              and Bharath 2019). The rampant LULC changes of a region will
              affect the exchanges of energy that take place between the
              biophysical properties of the Earth with the atmosphere. The
              comprehensive understanding of these changes are necessary to
              evaluate critical drivers of changes and frame polies for
              sustainable development (Ramachandra et al. 2017). Land surface
              temperature (LST) is a prime climate variable to account climate
              change across the local and global scales and it is also an
              indicator of the energy balance of the land surface processes
              (James and Mundia 2014). Changes in LST can be directly linked
              with associate LULC changes to account adverse effect on
              environment, energy balance and biogeochemical interactions.
            </p>
            <p>
              Global warming and consequent changes in the climate has given
              momentum to the research to understand the causes of LULC. LST is
              sensitive to vegetation, canopy layer and soil moisture, hence it
              can be used to detect LULC changes and link to climate alterations
              (Mallick et al. 2008). The unplanned developmental activities will
              intensify the environmental degradation, induce disasters,
              disrupting the sustainable economic growth (Ramachandra et al.
              2019). LST changes play an important role in most of the
              environmental processes and effect microclimate through associated
              biophysical changes. Increase in surface temperature has been
              observed due to conversions of pervious or vegetation surfaces to
              impervious surfaces. These changes in turn affect the absorption
              of solar radiation, surface temperature, evaporation rates and
              wind turbulence and alters the conditions of the near-surface
              atmosphere (Aithal et al. 2014). Thus, understanding linkages
              between LST and landscape dynamics help in evaluating
              human-environment interactions, aids in the planning and
              management of natural resources with persistent knowledge of
              landscape at temporal scale (Bharath et al. 2013). The advancement
              of spatial technologies has aided in understanding LULC changes,
              precise evaluation of LST and its environmental consequences. The
              temporal satellite remote sensing data of thermal band can capture
              the variation in energy across various features of landscape. The
              abundant studies have tried to capture LST using split-window
              algorithms in Landsat 8 using band 10 and 11 (Li et al. 2013;
              Bunai et al. 2018). Moderate Resolution Imaging Spectral
              radiometer (MODIS) data has more advantageous in LST estimation
              due to its global coverage, high radiometric resolution and
              dynamic ranges makes it efficient for monitoring and estimation of
              land surface temperature over a large area (Wan et al. 2002). The
              satellite derived LST of a larger region will provide information
              of different types of Earth surface processes, surface-atmosphere
              interactions and evapotranspiration (Anderson et al. 2011). The
              Karnataka state of India is experiencing the LULC changes due to
              increase in anthropogenic pressure from post 1990&rsquo;s. In this
              regard, the current research tries to understand the LULC changes
              at a temporal scale from 1985-2018 and tries to explore
              correlation between biophysical parameters of earth to sub pixel
              thermal variations based on agro climatic zones of Karnataka.
              Evaluation of temperature variations across forest and non-forest
              cover regions.
            </p>
            <h5>2. Understanding LST</h5>
            <p>
              Land Surface Temperature is a direction-based radiometric
              temperature of the collective surfaces on the earth as observed
              from the thermal region of the sensor onboard (
              <a href="#_bookmark79">Sismanidis et al., 2016</a>). It is a basic
              element of earth&rsquo;s thermal behavior and is an important
              index that determines the earth&rsquo;s energy balance and climate
              change (<a href="#_bookmark24">AATSR and SLSTR, 2018</a>). It is
              an important indicator of global warming and greenhouse effect (
              <a href="#_bookmark40">Jia et al., 2007</a>) and is directly
              linked with the sensible and latent heat fluxes, thus, playing a
              pivotal role in defining local, regional, as well as global
              processes over the surface of the earth (
              <a href="#_bookmark52">Mannstein, 1987</a>). One of the main
              advantages of estimating LST is that it provides the value of
              temperature at a pixel level, thus making it possible to capture
              and map even a very minute change in temperature which is not
              possible with measurements collected from meteo- rological
              stations especially in case of developing countries as they have
              only one meteorological station installed for a large area.
              Changes in landscape affect the overall evaporation and
              transpiration rates that alter the latent and sensible heat fluxes
              (<a href="#_bookmark56">Mojolaoluwa et al., 2018</a>). Scientific
              community across the globe have predicted that there would be
              higher climatic variation and increased thermal discomfort to the
              urban residents as a result of continuous rise in urban population
              because this will lead to increase in construction activities,
              rise in traffic congestions, and higher production of power
              supply. Fulfilling these needs would hamper the environment
              critically as they will lead to an increment in the concentration
              of pollutants in the air (PM<sub>10</sub>, PM<sub>2.5</sub>, PM
              <sub>1</sub>, and Suspended PM) as well as water (chemicals,
              leakages, discharges), and would also lead to a rise in GHGs (CO
              <sub>2</sub>, CO, NO<sub>X</sub>, SO<sub>X</sub>, O<sub>3</sub>,
              CH<sub>4</sub>) that further instigates increment in LST (
              <a href="#_bookmark55">Ministry of Statistic and Programme</a>{" "}
              <a href="#_bookmark55">Implementation, 2015</a>). Quantification
              of LST largely depends upon atmospheric parameters including
              atmospheric transmittance, upwelling and downwelling radiance,
              atmospheric water vapor content; sensor parameters such as viewing
              angle, sensor calibration, spectral range; surface parameters
              (surface albedo, land surface emissivity); and condition of the
              atmosphere (cloud cover) when the data are captured. Some of the
              selected (latest) studies performed by various researchers that
              relate LST and LULC (for reference) are as shown in{" "}
              <a href="#_bookmark2">Table 14.1</a>.
            </p>
            <p>
              A rise in LST not only critically affects the health and welfare
              of urban dwellers but also of the ones residing in rural as well
              as suburban areas. Elevated LST can affect us in multiple ways
              such as causing power outages, deteriorating the quality of air
              and water, causing severe health issues, affecting the thermal
              comfort, leading to food and water crisis, rising intensity and
              frequency of extreme weather events, and increasing mortality
              rates. Rise in LST also gives rise to a phenomenon of UHI that is
              an issue of serious concern these days.
            </p>
            <h5>3. Urban Heat Island</h5>
            <p>
              As a result of increased demographic pressure and in turn
              alteration in landscape toward increasing urban areas, cities
              these days are more susceptible to heatwaves and UHI phenomenon.
              This has now extended to such levels that the UHI effect is
              becoming a common phenomenon, is getting stronger, and is
              continuing for longer durations, which further aggravates thermal
              risk for the inhabitants (
              <a href="#_bookmark36">Founda and Santamouris, 2017</a>). UHI is a
              phenomenon observed in cities, where the city&rsquo;s temperature
              becomes higher compared to the nearby suburban or rural areas (
              <a href="#_bookmark50">Liang and Shi, 2009</a>).
              <br />
              <br />
            </p>

            <div class="container my-5">
              <h4 class="text-center mb-4">
                Table 14.1: Literature – Relationship between Land Surface
                Temperature and Urban Landscape
              </h4>
              <table class="table table-bordered table-striped">
                <thead class="table-dark">
                  <tr>
                    <th>Author</th>
                    <th>Inference</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Qian et al. (2020)</td>
                    <td>
                      Retrieved LST and emissivity from ground-based time-series
                      thermal infrared data
                    </td>
                  </tr>
                  <tr>
                    <td>Nimish et al. (2020)</td>
                    <td>
                      Explored temperature indices by deriving a relationship
                      between LST and urban landscape
                    </td>
                  </tr>
                  <tr>
                    <td>Guha et al. (2020)</td>
                    <td>
                      Performed long-term analysis on relationship between LST
                      and built-up index (NDBI)
                    </td>
                  </tr>
                  <tr>
                    <td>Wang and Murayama (2020)</td>
                    <td>
                      Performed geosimulation of LULC scenarios and identified
                      their impacts on LST for Sapporo, Japan
                    </td>
                  </tr>
                  <tr>
                    <td>Mustafa et al. (2020)</td>
                    <td>
                      Compared four algorithms to predict LST using Landsat data
                    </td>
                  </tr>
                  <tr>
                    <td>Daramola et al. (2018)</td>
                    <td>
                      Assessed thermal response of variations in the landscape
                      of an urban area
                    </td>
                  </tr>
                  <tr>
                    <td>Chandra et al. (2018)</td>
                    <td>
                      Performed geospatial analysis on the city of Jaipur,
                      India, to demonstrate a linkage between urban expansion
                      and LST
                    </td>
                  </tr>
                  <tr>
                    <td>Tran et al. (2017)</td>
                    <td>
                      Characterized relationship between changes in LULC and LST
                    </td>
                  </tr>
                  <tr>
                    <td>Pal and Ziaul (2017)</td>
                    <td>
                      Detected LULC changes and LST for pre-monsoon, monsoon,
                      and post-monsoon over English Bazar urban center
                    </td>
                  </tr>
                  <tr>
                    <td>Youneszadeh et al. (2015)</td>
                    <td>
                      Studied the effect of LU changes on LST over the
                      Netherlands
                    </td>
                  </tr>
                  <tr>
                    <td>Yu et al. (2014)</td>
                    <td>Compared various LST retrieval methods/algorithms</td>
                  </tr>
                  <tr>
                    <td>Bharath et al. (2013)</td>
                    <td>
                      Studied LST responses to landscape dynamics over central
                      Western Ghats in India
                    </td>
                  </tr>
                  <tr>
                    <td>Sobrino et al. (2006)</td>
                    <td>
                      Derived LST using an airborne hyperspectral thermal
                      infrared scanner
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p>
              These can be inferred to the difference in the percentage of
              vegetation, water, and impervious surface. UHIs can be divided
              into two categories:
            </p>
            <p>
              <ol>
                <li>
                  Atmospheric UHI (AUHI): As a result of absorption of heat in
                  the air due to the presence of particles, air temperature
                  increases causing AUHI It is further classified into two
                  categories based on height: canopy layer UHI (heat islands
                  present in air layer from surface level to the top of
                  buildings or vegetation), and boundary layer UHI (heat islands
                  present in the region above rooftops and vegetation).
                </li>
                <li>
                  Surface UHI (SUHI): This occurs as a result of higher surface
                  temperatures in urban areas due to the presence of large
                  region covered with impervious surfaces.
                </li>
              </ol>
            </p>
            <p>
              Some of the causal factors of UHI are multiple internal
              reflections, higher absorption of shortwave radiations, rise in
              anthropogenic heat sources, hindrance in the transmission of
              longwave radiations, lower evapotranspiration rates, changes in
              wind gust and turbulence, reduction in radiative cooling, etc. (
              <a href="#_bookmark33">Dash et al., 2002</a>). The main reasons
              behind these factors are the difference in the thermal properties
              of materials used for construction in urban areas when compared to
              the naturally occurring and imbalance in the composition of the
              landscape over a region. As a result of the difference in heat
              storage capacity of materials, the latent and sensible heat budget
              varies, leading to changes in the convective and advective energy
              flow (<a href="#_bookmark64">Oke, 1982</a>;{" "}
              <a href="#_bookmark72">Roth, 2012</a>).{" "}
              <a href="#_bookmark3">Fig. 14.1</a> shows a schematic
              representation of surface temperatures in urban, suburban, and
              rural areas.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh1.png" alt="" />{" "}
            </p>
            <p>
              <br /> FIGURE 14.1 Temperature distribution in urban, suburban,
              and rural areas signifying UHI.
              <br />
            </p>
            <p>
              Understanding UHI phenomena is one of the biggest challenges for
              the scientific community as it is directly related to providing
              apt infrastructure and a suitable environment for the residents (
              <a href="#_bookmark81">Stewart, 2011</a>). Interpretation of UHI
              was first studied in 1833 by Luke Howard over London, where he
              noticed the city center being warmer when compared to the
              countryside (<a href="#_bookmark54">Mills, 2008</a>). His
              annotation was then noticed and motivated many researchers raising
              concern regarding the exclusion of meteorology in the field of
              science. This triggered a need to perform UHI and LST studies over
              the cities as shown in <a href="#_bookmark4">Table 14.2</a>.
            </p>
            <p>
              The continual rise in surface temperature leads to discomfort that
              further increases energy consumption due to the increased usage of
              various electronic devices such as air conditioning and water
              coolers. This leads to increment in concentration of GHGs in the
              atmosphere leading to rising air temperatures that further
              instigates UHI. Rise in UHI is one of the most critical parameters
              to increase surface temperature. Thus this vicious cycle
              continues, further damaging human health and welfare. UHI not only
              affects human health but also disrupts complete urban ecological
              system. It affects the microclimate of the region and exerts
              tremendous pressure on the floral and faunal diversity especially
              on the ones that are sensitive to alteration in temperature. UHI
              also affects the evapotranspiration rates, that alters the
              moisture content in the atmosphere and earth&rsquo;s surface.
              Increased frequency and intensity of UHI can have numerous impacts
              on human health and welfare that includes cramps due to heat,
              difficulty in breathing and other pulmonary diseases, thermal
              discomfort, lethal and nonlethal heat strokes, exhaustion, etc. (
              <a href="#_bookmark35">EPA, 2019</a>). UHI is one of the key
              factors that lead to the generation of heatwaves and is solely
              responsible for many deaths.
              <br />
              <br />
            </p>
            <div className="container my-5">
              <h4 className="text-center mb-4">
                Table 14.2: Literature – LST and UHI Studies Over Cities
              </h4>
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Author</th>
                    <th>Inference</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Sarif et al. (2020)</td>
                    <td>
                      Assessed alterations in LULC and LST, further identified
                      their impact on SUHI over Kathmandu Valley for a period of
                      30 years
                    </td>
                  </tr>
                  <tr>
                    <td>Oh et al. (2020)</td>
                    <td>
                      Used deep learning algorithm for forecasting the magnitude
                      of UHI in Seoul and introduced a new index for determining
                      the same
                    </td>
                  </tr>
                  <tr>
                    <td>Kimuku and Ngigi (2017)</td>
                    <td>
                      Studied urban heat island trends and simulated LST for
                      2025 across Nakuru county in Kenya for aiding in urban
                      planning
                    </td>
                  </tr>
                  <tr>
                    <td>Mathew et al. (2016)</td>
                    <td>
                      Estimated UHI over the city of Chandigarh over a period of
                      4 years
                    </td>
                  </tr>
                  <tr>
                    <td>Grover and Singh (2015)</td>
                    <td>
                      Performed UHI analysis on Mumbai and identified the major
                      sectors behind the rise of UHI
                    </td>
                  </tr>
                  <tr>
                    <td>More et al. (2015)</td>
                    <td>
                      Compared estimation of UHI using LST and ambient air
                      temperature
                    </td>
                  </tr>
                  <tr>
                    <td>Murata et al. (2013)</td>
                    <td>
                      Calculated UHI by simulating biases in surface air
                      temperature using regional climatic model for Japan
                    </td>
                  </tr>
                  <tr>
                    <td>Wolters and Brandsma (2012)</td>
                    <td>
                      Estimated UHI in residential areas of Netherlands using
                      weather amateurs
                    </td>
                  </tr>
                  <tr>
                    <td>Gedzlman et al. (2003)</td>
                    <td>
                      Performed UHI analysis over New York City and identified
                      the intensity throughout the day
                    </td>
                  </tr>
                  <tr>
                    <td>Yamashita (1996)</td>
                    <td>
                      Estimated and compared UHI intensity over seasonal basis
                      for Tokyo
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p>&nbsp;</p>
            <h5>4. Significance of studying LST and UHI</h5>
            <p>
              As per a review paper published in{" "}
              <em>Environmental Research Letters</em>, 97% of the studies
              established that human-induced changes are the key source of
              rising global warming and climate change (
              <a href="#_bookmark61">NASA, 2018</a>). As per{" "}
              <a href="#_bookmark41">Jordon (2007)</a>, there are sufficient
              studies to prove and infer that the surface temperature of the
              earth is changing significantly at an alarming pace and is an
              issue of serious concern. As per a report by{" "}
              <a href="#_bookmark84">UN DESA (2018)</a>, 54% of the global
              population already reside in urban areas which are predicted to
              increase at a faster rate in the near future, majorly being
              concentrated in developing countries (
              <a href="#_bookmark31">Chen et al., 2014</a>). Exceptional rise is
              LST, and the phenomenon of UHI, affects almost all the sectors on
              which our life depends. These sectors include
            </p>
            <p>
              <ul>
                <li>
                  Energy: Higher energy consumption due to increased usage of
                  air conditioning, irrigation, and rise in fuel requirement in
                  the transportation sector (
                  <a href="#_bookmark78">Scott et al., 1990</a>).
                </li>
                <li>Agriculture: Crop failure can affect food</li>
                <li>
                  Water resources: Changes in the natural water cycle as a
                  result of alteration in the rate of evaporation and
                  precipitation. Melting of ice caps can also result in the rise
                  of sea level causing huge concern for the coastal cites (
                  <a href="#_bookmark30">Bolin et al., 1986</a>).
                </li>
                <li>
                  Forest: Rising temperatures can exert stress on few species,
                  thus making them vulnerable for fire, disease, and pest
                  infection.
                </li>
                <li>
                  Ecosystem biodiversity: Not every flora and fauna can sustain
                  large-scale changes in temperatures, thus, can gradually
                  become endangered or even extinct (
                  <a href="#_bookmark34">Davis, 1989</a>).
                </li>
                <li>
                  Air quality: Air pollution levels and temperature are
                  interdependent and rise in one can lead to an increment in the
                  other.
                </li>
              </ul>
              <ul>
                <li>
                  Infrastructure: Rising LST can affect the construction
                  material of the available infrastructure and can lead to
                  bending or breaking of some critical Damage can be in the form
                  of material as well as life.
                </li>
                <li>
                  Marine life: Alteration in temperature affects marine
                  biodiversity as a result of migration of few species from one
                  area to other (as they are unable to acclimatize to higher
                  temperatures) or can even lead to mass extinction (
                  <a href="#_bookmark77">
                    Science for Environmental Policy, 2007
                  </a>
                  ).
                </li>
              </ul>
            </p>
            <p>
              Human health: The increasing temperature can lead to increased
              skin diseases, asthma, migraine, stress, hay fever, and
              vector-borne diseases (<a href="#_bookmark68">Raloff, 1989</a>).
              <br />
              <br />
            </p>
            <h5>4. Theoretical background</h5>
            <p>
              Electromagnetic spectrum can be divided into various segments
              based on wavelength range, and their intensity varies with the
              transmission allowed by the atmospheric windows. One of the
              regions is dedicated to thermal remote sensing that can be defined
              between the wavelength range of 3e35 mm. Within this range, an
              excellent atmospheric window lies between 10 and 12 mm and thus,
              this region is used for various applications. The surface energy
              budget is a combination of radiative and nonradiative elements (
              <a href="#_bookmark74">Santra, 2019</a>). Radiative elements
              include incoming shortwave and outgoing longwave radiations, while
              latent heat and sensible heat form nonradiative components. Net
              energy is the summation of downward (heating of earth&rsquo;s
              surface) and upward (summation of reradiated energy and reflected
              radiation of the earth&rsquo;s surface) radiation. Two of the
              primary parameters that influence thermal remote sensing are
              albedo and land surface emissivity. Albedo can be defined as the
              fraction of the total energy incident on a surface that gets
              reflected (<a href="#_bookmark65">Oke and Cleugh, 1987</a>).
              Albedo varies with surface properties (type, shape, color, and
              size of the surface), angle of incidence, amount of aerosols and
              water vapor content in the atmosphere, and distribution of solar
              energy. Land surface emissivity can be elaborated as the ratio of
              energy radiated by any material to the energy emitted by a
              blackbody at the same wavelength and viewing angle under similar
              atmospheric conditions. This depends upon the composition of the
              material, surface roughness, and viewing angle (
              <a href="#_bookmark49">Li et al., 2013</a>). Application of
              thermal remote sensing can be explained via three basic laws as
              mentioned below:
            </p>
            <p style={{ textAlign: "center" }}>
              E = sT<sup>4</sup>.......(14.1)
            </p>
            <p>
              Here, E = Energy emitted; s = StephaneBoltzmann constant; T =
              Temperature in Kelvin.
            </p>
            <p style={{ textAlign: "center" }}>
              l<sub>m</sub> &times; T = 2897 mmK........(14.2)
            </p>
            <p>
              Here, T = Temperature in Kelvin; l<sub>m</sub> = Wavelength at
              which maximum radiation is achieved.
            </p>
            <p>
              This law also explains how thermal range for the earth&rsquo;s
              surface is obtained. Considering average temperature of
              earth&rsquo;s surface as 300K (27<sup>◦</sup>C), then as per{" "}
              <a href="#_bookmark6">Eq. (14.2)</a>, the wavelength at which peak
              radiation is obtained comes out to be 9.66 mm.
            </p>
            <p>&nbsp;</p>

            <p>
              <ul>
                <li>
                  Planck&rsquo;s law/function: relates spectral radiance of a
                  blackbody or nonblackbody with its temperature and is the
                  basis of deriving LST using thermal remote sensing. Since
                  there is no blackbody, emissivity is used with blackbody
                  radiance to derive nonblackbody radiance
                </li>
              </ul>
            </p>
            <p>
              (<a href="#_bookmark7">Eq. 14.3</a>) and further temperature.
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh143.png" alt="" />
              .........(14.3){" "}
            </p>

            <p>
              Here, R
              <sub>
                l<em>,</em>T
              </sub>{" "}
              = Spectral radiance of nonblack body at wavelength l and
              temperature T (in Wm<sup>&mdash;2</sup>mm<sup>&mdash;1</sup>sr
              <sup>&mdash;1</sup>); B<sub>l,T</sub> = Spectral radiance of black
              body at wavelength l and temperature T (in Wm<sup>&mdash;2</sup>mm
              <sup>&mdash;1</sup>sr<sup>&mdash;1</sup>) [Planck&rsquo;s
              radiation law]; l = Wavelength (mm); T = Temperature (K);
              &epsilon;<sub>l</sub>&nbsp; emissivity of the body at wavelength
              l; C<sub>1</sub> and C<sub>2</sub> are radiation constants.
            </p>
            <p>
              The surface temperature of objects with a Lambertian surface with
              known emissivity can be determined as shown in{" "}
              <a href="#_bookmark8">Eq. (14.4)</a>.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh144.png" alt="" />
              .........(14.4){" "}
            </p>

            <h5>6. Practical example</h5>
            <p>
              This section of the chapter provides a case study to understand
              the effect of increasing urbanization on the land surface
              temperature. Further, it deals with the estimation of UHI index
              and concluded with the suggestion of mitigation measures for
              minimizing the discomfort of the residents. The following
              subsection provides detailed information about the study area,
              method used, and observed results.
            </p>
            <p>
              <ul>
                <li>
                  Wein&rsquo;s displacement law: states that radiation by
                  blackbody will reach its peak at different temperatures
                  depending on its Higher the temperature, it will have peak
                  radiation at lower wavelengths. Mathematically it can be
                  expressed as <a href="#_bookmark6">Eq. (14.2)</a>.
                </li>
                <li>
                  StephaneBoltzmann law: explains the relationship between
                  energy radiated and the temperature of an object as shown in{" "}
                  <a href="#_bookmark5"> (14.1)</a>. The law signifies that any
                  object above 0K emits energy equivalent to the fourth power of
                  its absolute temperature.
                </li>
              </ul>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
